import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { NgxTolgeeModule } from "@tolgee/ngx";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatFormField, MatLabel, MatPrefix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { MatIcon } from "@angular/material/icon";

@Component({
	selector: "app-new-protocol-note",
	imports: [
		MatDialogTitle,
		MatDialogContent,
		MatDialogActions,
		MatButton,
		MatDialogClose,
		MatProgressSpinner,
		NgxTolgeeModule,
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		MatIcon,
		MatPrefix,
	],
	templateUrl: "./new-protocol-note.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: "./new-protocol-note.component.scss",
})
export class NewProtocolNoteComponent {
	isLoading: boolean = false;
	anchor: string = "";
	notes: string = "";

	get isReady(): boolean {
		return false;
	}

	create(): void {}
}
